var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00271 0.000329365C2.24062 0.000236721 0.00152063 2.23622 0.00192805 4.99831C0.00254142 9.1566 0.00306323 15.1564 0.0020333 19.9968C0.00144543 22.7596 2.23737 25.0002 5.00018 25.0002C9.15968 25.0002 15.1609 25.0002 20.0014 25.0002C22.7628 25.0002 25.001 22.765 25.001 20.0037C25.001 15.8443 25.001 9.84153 25.001 4.99983C25.001 2.23845 22.7625 0.000144643 20.0011 0.000181137C15.0017 0.000247209 10.0022 0.000497053 5.00271 0.000329365Z",
    fill: "#419FD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6144 19.2381C17.5656 19.6543 17.9223 18.7824 17.9223 18.7824L20.4389 6.13968C20.4191 5.28758 19.2698 5.8028 19.2698 5.8028L5.18051 11.3315C5.18051 11.3315 4.50677 11.5693 4.56621 11.9854C4.62566 12.4016 5.1607 12.5997 5.1607 12.5997L8.70778 13.7887C8.70778 13.7887 9.77785 17.2962 9.99583 17.9699C10.194 18.6238 10.3723 18.6437 10.3723 18.6437C10.5705 18.7229 10.7488 18.5842 10.7488 18.5842L13.0475 16.5035L16.6144 19.2381ZM17.2284 8.37887C17.2284 8.37887 17.7238 8.08163 17.704 8.37887C17.704 8.37887 17.7832 8.4185 17.5256 8.69593C17.2878 8.93372 11.6799 13.967 10.9268 14.6408C10.8674 14.6804 10.8278 14.7398 10.8278 14.8191L10.6098 16.6818C10.5702 16.88 10.3125 16.8998 10.2531 16.7215L9.32174 13.6698C9.2821 13.5509 9.32174 13.4122 9.44063 13.3329L17.2284 8.37887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.eec7b86ac5e2eff7d1b8858ee9055909.svg";
export { ForwardRef as ReactComponent };